import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom/client';
//import reportWebVitals from "./reportWebVitals";
import App from './App';
import "./tailwind.css";
import "./i18next";
const root = ReactDOM.createRoot(document.getElementById('root'));
console.log('index.ts start');
root.render(_jsx(App, {}));
